export const CalendarType = {
  TASKLIST: 'TASKLIST',
  SIMPLETASK: 'SIMPLETASK',
};
